// =============================================================================
// Company details used across the website. Fill in the real phone / WhatsApp / email.
// =============================================================================
export const SITE = {
    name: 'Hirsta',
    siteUrl: 'https://hirsta.com',   // the website's own address (no trailing slash). Change if different.
    tagline: 'Salon software that grows your revenue, brand and repeat clients',
    description: 'Hirsta is salon software for India: GST billing, memberships, prepaid cards, service packages, appointments, staff payroll and WhatsApp marketing that help salons grow revenue and bring clients back.',
    ogImage: '/og-image.png',
    appUrl: 'https://app.hirsta.com',
    loginUrl: 'https://app.hirsta.com/login',
    phone: '+91 00000 00000',        // shown on the site
    whatsapp: '910000000000',        // country code + number, digits only (used for wa.me links)
    email: 'hello@hirsta.com',
    city: 'Noida, India',
};

export const NAV = [
    { label: 'Features', to: '/features' },
    { label: 'Packages', to: '/features#packages' },
    { label: 'Grow sales', to: '/#growth' },
    { label: 'Contact', to: '/demo' },
];

export const waLink = (text = '') => `https://wa.me/${SITE.whatsapp}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
